import {
  GraduationCap,
  Briefcase,
  Heart,
  BookOpen,
  Circle,
  Layers,
  X,
  MapPin,
  Calendar,
  Clock,
  type LucideIcon
} from 'lucide-react';

export const iconMap: Record<string, LucideIcon> = {
  GraduationCap,
  Briefcase,
  Heart,
  BookOpen,
  Circle,
  Layers,
  X,
  MapPin,
  Calendar,
  Clock
};

export const resolveIcon = (name: string): LucideIcon => {
  return iconMap[name] || Circle;
};
